module.exports = __webpack_public_path__ + "static/img/login_bg.007d9d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg.jpg
// module id = 1146
// module chunks = 1